import { CreateUserCommand, TenantRoleDto, UpdateUserCommand, UserDto } from '@admin/app/api'
import { BaseDataStore } from '@admin/app/store/basedata.store'
import { userService } from '@admin/services/user.service'
import { computed, makeObservable, observable, runInAction } from 'mobx'

export class UserStore extends BaseDataStore<UserDto> {
  selectedUserRoles: TenantRoleDto[] = []

  constructor() {
    super()
    makeObservable(this, {
      selectedUserRoles: observable,

      usersSorted: computed,
    })
  }

  get usersSorted() {
    return [...this.data].sort((a, b) => (a.email ?? '').localeCompare(b.email ?? ''))
  }

  async load() {
    const users = await userService.load()
    runInAction(() => {
      this.data = users
    })
  }

  async add(createUserCommand: CreateUserCommand) {
    const data = await userService.create(createUserCommand)
    runInAction(() => (this.data = [...this.data, data]))

    return data.user_id
  }

  async update(updateUserCommand: UpdateUserCommand) {
    const data = await userService.update(updateUserCommand)
    runInAction(() => {
      this.data = [...this.data.filter(e => e.user_id !== updateUserCommand.userId), data]
    })

    return data.user_id
  }

  async delete(userId: string) {
    await userService.delete(userId)
    runInAction(() => (this.data = [...this.data.filter(e => e.user_id !== userId)]))
  }

  async loadUserRoles(userId: string) {
    const roles = await userService.loadUserRoles(userId)
    runInAction(() => (this.selectedUserRoles = roles))
  }

  async updateUserRoles(userId: string, roleIds: number[]) {
    await userService.updateUserRoles(userId, roleIds)
  }

  async getUserMetadata(userId: string) {
    const metadata = await userService.getUserMetadata(userId)
    return metadata
  }
}
